/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type StartExportRequestSchemaNameRedaction = typeof StartExportRequestSchemaNameRedaction[keyof typeof StartExportRequestSchemaNameRedaction];


export const StartExportRequestSchemaNameRedaction = {
  none: 'none',
  last_initial: 'last_initial',
  no_last_name: 'no_last_name',
  initials_only: 'initials_only',
  anonymized: 'anonymized',
} as const;
